import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

function OrdersTransactionsController(
  $scope,
  $state,
  $filter,
  $timeout,
  HelpersService,
  CalendarService,
  UserPreferencesService,
  NoticeFactory,
  ApiService,
  GridDefinitionFactory,
  GridStateFactory,
  TransactionsData
) {
  $scope.ordersTransactions = {
    model: [],
    filtered: [],
    searchQuery: '',
    orderId: '',
    viewId: '',
    isLoaded: false,
    notice: new NoticeFactory(),
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    orderTransactionsListGridName: $state.current.name + '.grid0',

    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

    optionsOverride: {
      useAccessibleGrid: true,
      data: 'ordersTransactions.filtered',
      //gridDefinition options override, no backend pagination support for transactions
      useExternalPagination: false,
      useExternalSorting: false,
      appScopeProvider: {
        onDblClick: function (item) {
          $scope.ordersTransactions.onDblClick(item);
        },
        customClientFilter: function (renderableRows) {
          return $filter('filter')(renderableRows, function (obj) {
            const name = obj.entity.transaction;
            const value = JSON.stringify(name).toLowerCase();

            return value.indexOf($scope.ordersTransactions.searchQuery.toLowerCase()) !== -1
              ? obj.entity.transaction
              : null;
          });
        },
      },
      columnDefs: [
        {
          field: 'view',
          displayName: 'View',
          width: 50,
          onCellNavClick: function (row, col) {
            $scope.ordersTransactions.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details</span></a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'transaction.id',
          displayName: 'Transaction Id',
          visible: false,
          colId: 'id',
        },
        {
          field: 'transaction.orderNumber',
          displayName: 'Order No.',
          visible: false,
          colId: 'orderNumber',
        },
        {
          field: 'transaction.contactFirstName',
          displayName: 'Contact First Name',
          visible: true,
          colId: 'contactFirstName',
        },
        {
          field: 'transaction.contactLastName',
          displayName: 'Contact Last Name',
          visible: true,
          colId: 'contactLastName',
        },
        {
          field: 'transaction.email',
          displayName: 'Email',
          visible: false,
          colId: 'contactEmail',
        },
        {
          field: 'transaction.phoneNumber',
          displayName: 'Phone Number',
          visible: false,
          colId: 'contactPhoneNumber',
        },
        {
          field: 'transaction.address1',
          displayName: 'Address 1',
          visible: false,
          colId: 'contactAddress1',
        },
        {
          field: 'transaction.address2',
          displayName: 'Address 2',
          visible: false,
          colId: 'contactAddress2',
        },
        {
          field: 'transaction.city',
          displayName: 'City',
          visible: false,
          colId: 'contactCity',
        },
        {
          field: 'transaction.state',
          displayName: 'State',
          visible: false,
          colId: 'contactState',
        },
        {
          field: 'transaction.zipCode',
          displayName: 'Zip Code',
          visible: false,
          colId: 'contactZipCode',
        },
        {
          field: 'transaction.country',
          displayName: 'Country',
          visible: false,
          colId: 'contactCountry',
        },
        {
          field: 'transaction.billingFirstName',
          displayName: 'Billing First Name',
          visible: true,
          colId: 'billingFirstName',
        },
        {
          field: 'transaction.billingLastName',
          displayName: 'Billing Last Name',
          visible: true,
          colId: 'billingLastName',
        },
        {
          field: 'transaction.billingEmail',
          displayName: 'Billing Email',
          visible: false,
          colId: 'billingEmail',
        },
        {
          field: 'transaction.billingPhoneNumber',
          displayName: 'Billing Phone Number',
          visible: false,
          colId: 'billingPhoneNumber',
        },
        {
          field: 'transaction.billingAddress1',
          displayName: 'Billing Address 1',
          visible: false,
          colId: 'billingAddress1',
        },
        {
          field: 'transaction.billingAddress2',
          displayName: 'Billing Address 2',
          visible: false,
          colId: 'billingAddress2',
        },
        {
          field: 'transaction.billingCity',
          displayName: 'Billing City',
          visible: false,
          colId: 'billingCity',
        },
        {
          field: 'transaction.billingState',
          displayName: 'Billing State',
          visible: false,
          colId: 'billingState',
        },
        {
          field: 'transaction.billingZipCode',
          displayName: 'Billing Zip Code',
          visible: false,
          colId: 'billingZipCode',
        },
        {
          field: 'transaction.billingCountry',
          displayName: 'Billing Country',
          visible: false,
          colId: 'billingCountry',
        },
        {
          field: 'transaction.discountedTransactionAmount',
          displayName: 'Amount',
          visible: true,
          colId: 'discountedTransactionAmount',
        },
        {
          field: 'transaction.orderBalance',
          displayName: 'Balance Due',
          visible: true,
          colId: 'orderBalance',
        },
        {
          field: 'transaction.transactionType',
          displayName: 'Type',
          visible: true,
          colId: 'transactionType',
        },
        {
          field: 'transaction.paymentMethod',
          displayName: 'Payment Method',
          visible: true,
          colId: 'paymentMethod',
        },
        {
          field: 'transaction.creditCardBrand',
          displayName: 'Credit Card Brand',
          visible: true,
          colId: 'creditCardBrand',
        },
        {
          field: 'transaction.paymentStatus',
          displayName: 'Status',
          visible: true,
          colId: 'paymentStatus',
        },
        {
          field: 'transaction.userLogin',
          displayName: 'Transaction User Login',
          visible: false,
          colId: 'userLogin',
        },
        {
          field: 'transaction.terminalId',
          displayName: 'Terminal ID',
          visible: true,
          colId: 'terminalId',
        },
        {
          field: 'transaction.transactionDisplayDate',
          displayName: 'Transaction Date',
          visible: true,
          colId: 'transactionDisplayDate',
          sort: {
            direction: 'desc',
          },
        },
      ],
    },

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Order Transactions',
        buttonLeft: {
          label: 'Back',
          action: function () {
            window.history.go(-1);
          },
        },
        buttonRight: {
          label: 'Edit Order',
          permissions: ['ORDER_UPDATE'],
          action: function () {
            $state.go('application.orders.edit', { orderId: $scope.ordersDetail.model.orderId });
          },
          isDisabled: $scope.ordersDetail.isDisabled(),
        },
      });

      this.orderId = $state.params.orderId;
      this.viewId = $state.current.name;
      $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

      this.gridDefinition.init(
        this.orderTransactionsListGridName,
        this.optionsOverride,
        this.viewId,
        $state.current.data.enablePreferences
      );
    },

    search: function () {
      this.filtered = $filter('filter')(this.model, function (transaction) {
        const name = transaction.transaction;
        const value = JSON.stringify(name).toLowerCase();

        return value.indexOf($scope.ordersTransactions.searchQuery.toLowerCase()) !== -1 ? transaction : null;
      });
    },

    query: function () {
      const self = $scope.ordersTransactions;
      self.search();
      $scope.$broadcast('DataGrid::ResizeGrid', {
        name: self.orderTransactionsListGridName,
        datasetLength: self.filtered.length,
      });
    },

    cancel: function () {
      $state.go('application.orders.detail.summary', { orderId: $state.params.orderId });
    },

    initData: function () {
      const self = $scope.ordersTransactions;

      if (TransactionsData && TransactionsData.data.success) {
        self.success.init(TransactionsData);
      } else {
        self.error.init(TransactionsData);
      }
    },

    hasTransactions: function () {
      return this.model instanceof Array && this.model.length > 0;
    },

    process: function (transactions: any[]) {
      const transactionIds: any[] = [];
      const processedTransactions: any[] = [];

      for (let i = 0; i < transactions.length; i++) {
        if (transactionIds.indexOf(transactions[i].transaction.id) < 0) {
          transactionIds.push(transactions[i].transaction.id);
          transactions[i].transaction.orderBalance = $filter('currency')(transactions[i].transaction.orderBalance || 0);
          transactions[i].transaction.orderAmount = $filter('currency')(transactions[i].transaction.orderAmount || 0);
          transactions[i].transaction.discountedOrderAmount = $filter('currency')(
            transactions[i].transaction.discountedOrderAmount || 0
          );
          transactions[i].transaction.transactionAmount = $filter('currency')(
            transactions[i].transaction.transactionAmount || 0
          );
          transactions[i].transaction.netTransactionAmount = $filter('currency')(
            transactions[i].transaction.netTransactionAmount || 0
          );
          transactions[i].transaction.discountedTransactionAmount = $filter('currency')(
            transactions[i].transaction.discountedTransactionAmount || 0
          );
          transactions[i].transaction.resellerServiceFee = $filter('currency')(
            transactions[i].transaction.resellerServiceFee || 0
          );
          transactions[i].transaction.resellerServiceFeePercentage += '%';
          transactions[i].transaction.serviceFee = $filter('currency')(transactions[i].transaction.serviceFee || 0);
          transactions[i].transaction.serviceFeePercentage += '%';
          transactions[i].transaction.fixedFee = $filter('currency')(transactions[i].transaction.fixedFee || 0);
          transactions[i].transaction.percentFee = $filter('currency')(transactions[i].transaction.percentFee || 0);
          transactions[i].transaction.transactionDisplayDate = $filter('date')(
            CalendarService.parseDate(transactions[i].transaction.transactionDate),
            UserPreferencesService.getDateFormat('sortDate', 'dateFormat')
          );
          transactions[i].transaction.parentTransactionDisplayDate = $filter('date')(
            CalendarService.parseDate(transactions[i].transaction.parentTransactionDate),
            UserPreferencesService.getDateTimeFormat('sortDateTime')
          );
          processedTransactions.push(transactions[i]);
        }
      }

      return processedTransactions;
    },

    success: {
      init: function (response) {
        const self = $scope.ordersTransactions;

        self.model = self.process(angular.copy(response.data.payload));

        self.search();

        if (!$scope.$$phase) {
          $scope.$apply();
        }
        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;
        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.filtered.length,
            totalItems: self.filtered.length,
          });
        }, 10);
      },
    },

    error: {
      init: function (response) {},
    },

    onDblClick: function (item) {
      // Create and edit are handled by the same controller
      console.log('ProgramsOrdersTransactionsController::onGridDblClick', item.entity.transaction.id);
      $state.go('application.orders.detail.transactions.detail', {
        orderId: item.entity.transaction.orderId,
        id: item.entity.transaction.id,
      });
    },
  };

  $scope.ordersTransactions.init();
}

OrdersTransactionsController.$inject = [
  '$scope',
  '$state',
  '$filter',
  '$timeout',
  'HelpersService',
  'CalendarService',
  'UserPreferencesService',
  'NoticeFactory',
  'ApiService',
  'GridDefinitionFactory',
  'GridStateFactory',
  'TransactionsData',
];

export const OrderDetailsTransactionsControllerModule = angular
  .module('acme.view.application.orders.detail.transactions.controllers', [
    uiRouter,
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.userPreferences',
  ])

  .controller('OrdersTransactionsController', OrdersTransactionsController).name;
